module.exports = __webpack_public_path__ + "media/images/favicon-2bf91756910ccabe018e12ac0e608d34.png";